import { Payload, payloadSchema } from 'embedded/api/in/messages/Payload';
import { JSONSchemaType } from 'ajv';

export interface AuthenticateMessagePayload extends Payload {
    /*
     * JWT token
     */
    token: string;
    /*
     * Host application name
     */
    application: string;
    applicationVersion: string;
    machineId?: string;
}

export const authenticatePayloadSchema: JSONSchemaType<AuthenticateMessagePayload> =
    {
        type: 'object',
        properties: {
            ...payloadSchema.properties,
            token: {
                type: 'string',
                minLength: 1,
            },
            application: {
                type: 'string',
                minLength: 1,
            },
            applicationVersion: {
                type: 'string',
                minLength: 1,
            },
            machineId: {
                type: 'string',
            },
        },
        required: ['token', 'application', 'applicationVersion'],
        additionalProperties: true,
    };
